/*
 *
 *  A module for toggle
 * 
 *  Implementation: 
 * 
 *  import { toggle } from "./components/toggle/toggle.js";
 *  let toggleInstance = new toggle( 'data-link', 'data-target', 'active' );
 * 
*/

export function toggle(link, target, active) {

    var elems = document.querySelectorAll('[' + link + ']');
    
    elems.forEach(function (elem, index) {

        elem.addEventListener('click', () => {

            let tgts = document.querySelectorAll('[data-target="' + elem.dataset.link + '"]');
            tgts.forEach(function (tgt, index) {

                if(tgt.classList.contains(active)) {
                    tgt.classList.remove(active);
                } else {
                    tgt.classList.add(active);
                }

            });

        });
    });

    return (
        console.log('mod-toggle Initialised')
    )
}